import { createAsyncThunk } from '@reduxjs/toolkit';
import { _speechToTextUsers } from '@custom/Utils/constants/apiUrls';

 const checkSpeechToTextUser = createAsyncThunk(
  'checkSpeechToTextUser',
  async (payload, { rejectWithValue }) => {
    const url = _speechToTextUsers.getSpeechToTextUsers;
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({hospitalId: hospitalId})
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to add research data. Status code: ${response?.status}`);
      }

      return await response.json();

    } catch (error) {
      return rejectWithValue(`Failed to add research data. Status code: ${error}`);
    }
  }
);

export default checkSpeechToTextUser;
